import { render, staticRenderFns } from "./navbarLight.vue?vue&type=template&id=4ec616c3&scoped=true&"
import script from "./navbarLight.vue?vue&type=script&lang=js&"
export * from "./navbarLight.vue?vue&type=script&lang=js&"
import style0 from "./navbarLight.vue?vue&type=style&index=0&id=4ec616c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec616c3",
  null
  
)

export default component.exports